export const REPORT_REQUEST_STATUS = {
    None: 0,
    Saving: 1,
    Success: 2,
    Error: -1,
    ErrorAllRequiredFieldsAreNeeded: -2,
}



// WEBPACK FOOTER //
// ./app/web/src/container/RequestReportPage/constants.js